/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {AccountManagerSettings} from '../models/AccountManagerSettings';
import type {AccountManagerSettingsSaveRequest} from '../models/AccountManagerSettingsSaveRequest';
import type {Error} from '../models/Error';

export interface GetAccountManagerSettings$Request {
    accountManagerId: number;
}

export interface GetAccountManagerSettings$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAccountManagerSettingsRequest = createAction<PayloadData<void, GetAccountManagerSettings$Request>>('ACCOUNT_MANAGER_SETTINGS_CONTROLLER__GET_ACCOUNT_MANAGER_SETTINGS__REQUEST');
export const getAccountManagerSettingsSuccess = createAction<PayloadData<AccountManagerSettings, GetAccountManagerSettings$Request>>('ACCOUNT_MANAGER_SETTINGS_CONTROLLER__GET_ACCOUNT_MANAGER_SETTINGS__SUCCESS');
export const getAccountManagerSettingsFailure = createAction<PayloadData<Error, GetAccountManagerSettings$Request, true>>('ACCOUNT_MANAGER_SETTINGS_CONTROLLER__GET_ACCOUNT_MANAGER_SETTINGS__FAILURE');

export const getAccountManagerSettingsActions = [
    getAccountManagerSettingsRequest,
    getAccountManagerSettingsSuccess,
    getAccountManagerSettingsFailure
] as const;

/**
 * @param {number} meta.accountManagerId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAccountManagerSettings = (meta: GetAccountManagerSettings$Request, config?: GetAccountManagerSettings$Config) => {
    return {
        CALL_API: {
            types: getAccountManagerSettingsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/account-managers/${meta.accountManagerId}/settings`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface SaveAccountManagerSettings$Request {
    accountManagerId: number;
    accountManagerSettingsSaveRequest?: AccountManagerSettingsSaveRequest;
}

export interface SaveAccountManagerSettings$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const saveAccountManagerSettingsRequest = createAction<PayloadData<void, SaveAccountManagerSettings$Request>>('ACCOUNT_MANAGER_SETTINGS_CONTROLLER__SAVE_ACCOUNT_MANAGER_SETTINGS__REQUEST');
export const saveAccountManagerSettingsSuccess = createAction<PayloadData<void, SaveAccountManagerSettings$Request>>('ACCOUNT_MANAGER_SETTINGS_CONTROLLER__SAVE_ACCOUNT_MANAGER_SETTINGS__SUCCESS');
export const saveAccountManagerSettingsFailure = createAction<PayloadData<Error, SaveAccountManagerSettings$Request, true>>('ACCOUNT_MANAGER_SETTINGS_CONTROLLER__SAVE_ACCOUNT_MANAGER_SETTINGS__FAILURE');

export const saveAccountManagerSettingsActions = [
    saveAccountManagerSettingsRequest,
    saveAccountManagerSettingsSuccess,
    saveAccountManagerSettingsFailure
] as const;

/**
 * @param {number} meta.accountManagerId
 * @param {AccountManagerSettingsSaveRequest} [meta.accountManagerSettingsSaveRequest]
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const saveAccountManagerSettings = (meta: SaveAccountManagerSettings$Request, config?: SaveAccountManagerSettings$Config) => {
    return {
        CALL_API: {
            types: saveAccountManagerSettingsActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/account-managers/${meta.accountManagerId}/settings`,
            TRANSPORT_REQUEST_BODY: meta.accountManagerSettingsSaveRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

